export const SHA_SCENARIOS = [1, 2, 3, 4, 5, 6, 7, 8].map(n => ({
  id: n,
  fund: ['', 'SHIF', 'SHIF', 'SHIF', 'SHIF', 'SHIF', 'UHC', 'ECCIF', 'ECCIF'][n] as string,
  label: ['', 'SHIF IP Per Diem', 'SHIF IP FFS Normal', 'SHIF IP FFS Elective', 'SHIF OP FFS Elective', 'SHIF OP FFS Normal', 'UHC OP Capitation', 'ECCIF Emergency (ID)', 'ECCIF Emergency (Unknown)'][n],
  isIP: [1, 2, 3].includes(n),
  isOP: [4, 5, 6].includes(n),
  isEM: [7, 8].includes(n),
  isPerDiem: n === 1,
  isCapitation: n === 6,
}));

function flagYes(v: any): boolean {
  if (v === true || v === 1) return true;
  if (v === false || v === 0 || v == null || v === '') return false;
  const s = String(v).trim().toUpperCase();
  return s === 'YES' || s === 'TRUE' || s === '1' || s === 'Y';
}

export function interventionIsElective(iv: any): boolean {
  if (flagYes(iv?.needsManualPreauthApproval)) return true;
  const m = String(iv?.automateOrManual || iv?.automate_or_manual || '').trim();
  if (!m) return false;
  if (/peer\s*review/i.test(m)) return true;
  if (/^manual\s*$/i.test(m)) return true;
  return false;
}

export function detectScenario(iv: any, claimServiceType?: string, fundHint?: string, unidentified?: boolean): number {
  const fund = String(fundHint || iv?.fund || '').toUpperCase();
  const pm = String(iv?.paymentMechanism || iv?.payment_mechanism || '').replace(/[\s-]+/g, '_').toUpperCase();
  const needsPreauth = flagYes(iv?.needsPreauth ?? iv?.needs_preauth ?? iv?.requiresPreAuth);
  const elective = interventionIsElective(iv);
  const st = String(claimServiceType || iv?.serviceType || '').toUpperCase();
  const ap = String(iv?.accessPoint || iv?.accessPath || '').toUpperCase();

  const isEM = st === 'EMERGENCY' || st === 'ECCIF';
  let isIP = st === 'INPATIENT' || st === 'IP';
  let isOP = st === 'OUTPATIENT' || st === 'OP' || st === 'CAPITATION';
  if (!isEM && !isIP && !isOP) {
    const hasIP = ap.includes('IP');
    const hasOP = ap.includes('OP');
    if (hasIP && !hasOP) isIP = true;
    else if (hasOP && !hasIP) isOP = true;
    else isIP = true;
  }

  if (unidentified && (isEM || fund === 'ECCIF')) return 8;
  if (isEM || (fund === 'ECCIF' && !isIP && !isOP)) return 7;
  if (fund === 'ECCIF' && isEM) return unidentified ? 8 : 7;
  if (fund === 'UHC' && (isOP || pm === 'CAPITATION' || st === 'CAPITATION')) return 6;
  if (pm === 'CAPITATION' && (isOP || !isIP)) return 6;

  if (isIP) {
    if (pm === 'PER_DIEM' || (!needsPreauth && pm !== 'FEE_FOR_SERVICE')) return 1;
    if (needsPreauth && elective) return 3;
    if (needsPreauth) return 2;
    return 1;
  }
  if (needsPreauth && elective) return 4;
  return 5;
}

export function inferScenarioFromSearch(search: string): number {
  const p = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const explicit = +(p.get('scenario') || 0);
  if (explicit >= 1 && explicit <= 8) return explicit;
  const from = (p.get('from') || '').toLowerCase();
  const st = (p.get('serviceType') || '').toUpperCase();
  const fund = (p.get('fund') || '').toUpperCase();
  const unidentified = p.get('unidentified') === '1' || p.get('unknown') === '1' || from === 'unknown';
  if (unidentified) return 8;
  if (p.get('emergencyCaseId') || from === 'emergency' || st === 'EMERGENCY' || fund === 'ECCIF') return 7;
  if (from === 'uhc' || fund === 'UHC' || st === 'CAPITATION') return 6;
  const fromIp = ['ipd', 'ot', 'icu', 'bed', 'bed-board', 'maternity-delivery'].includes(from);
  const fromOp = ['opd', 'lab', 'laboratory', 'radiology', 'pharmacy', 'ophthalmology', 'telemedicine', 'renal', 'mental', 'palliative', 'maternity', 'appointment', 'cpoe', 'emr', 'fob', 'billing', 'bloodbank'].includes(from);
  if (p.get('admissionId') || fromIp || st === 'INPATIENT') return 1;
  if (p.get('visitId') || fromOp || from === 'opd' || st === 'OUTPATIENT') return 5;
  return 1;
}

export function claimFieldsForScenario(n: number) {
  const sn = SHA_SCENARIOS.find(s => s.id === n) || SHA_SCENARIOS[0];
  return {
    scenario: `SCENARIO_${sn.id}`,
    fund: sn.fund,
    serviceType: sn.isEM ? 'EMERGENCY' : sn.isIP ? 'INPATIENT' : sn.isCapitation ? 'OUTPATIENT' : 'OUTPATIENT',
    paymentMechanism: sn.isPerDiem ? 'PER_DIEM' : sn.isCapitation ? 'CAPITATION' : 'FEE_FOR_SERVICE',
  };
}
